// src/app/services/barcode/barcode.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewBarcodeComponent } from './barcode.component';
import { NewBarcodeDirective } from './barcode.directive';
import { Code128Service } from './code128.service';

@NgModule({
  declarations: [
    NewBarcodeComponent,
    NewBarcodeDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NewBarcodeComponent,
    NewBarcodeDirective
  ],
  providers: [
    Code128Service
  ]
})
export class BarcodeModule { }
